import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiFestivalOffersList, apiFestivalOffersView } from 'Services/UserService'

export const getData = createAsyncThunk('user/festivalOffers/getData', async datas => {
    const { data } = await apiFestivalOffersList(datas)
    return data
})

export const getView = createAsyncThunk('user/festivalOffers/getView', async id => {
    if (!id) return viewData
    const { data } = await apiFestivalOffersView(id)
    data.image = ''
    return data
})

const viewData = {
    title: '',
    description: '',
    start_date: '',
    end_date: '',
    image: '',
}

export const festivalOffersSlice = createSlice({
    name: 'user/festivalOffers',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = festivalOffersSlice.actions

export default festivalOffersSlice.reducer
